import React, { useState } from 'react';

// Uploaded files are served from the API host, not /api. Stored values are
// root-relative paths ("/uploads/avatars/..."), but S3 setups hand back absolute
// URLs — pass both through unchanged.
const API_ORIGIN = (import.meta.env.VITE_API_URL || 'http://localhost:5000/api').replace(/\/api\/?$/, '');

export const resolveUploadUrl = (path) => {
  if (!path) return null;
  return path.startsWith('http') ? path : `${API_ORIGIN}${path}`;
};

/**
 * A stored profile picture, with a caller-supplied fallback.
 *
 * Deliberately renders `fallback` verbatim rather than imposing its own initials
 * styling — each screen already has its own avatar look (tinted circle on the
 * staff list, gradient circle on the staff header) and those stay pixel-identical
 * for anyone who hasn't uploaded a photo.
 *
 * Falls back on a missing path *and* on a load error, so a deleted or unreachable
 * file shows initials instead of a broken-image icon.
 */
const UserPhoto = ({ src, alt = '', className = '', fallback = null }) => {
  const [failed, setFailed] = useState(false);
  const url = resolveUploadUrl(src);

  if (!url || failed) return fallback;

  return (
    <img
      src={url}
      alt={alt}
      onError={() => setFailed(true)}
      className={`object-cover shrink-0 ${className}`}
    />
  );
};

export default UserPhoto;
